import React, { useEffect, useState } from "react";
import  { useNavigate, Navigate } from 'react-router-dom'
import { baseUrl } from "../shared";
import '../pages/App.css';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { Toggle } from './ui';

export function UpdateUser({ onClose }) {
    const [changed, setChanged] = useState(false);
    var [userEdit, setUserEdit] = useState({});
    var [modUser, setModUser] = useState({});
    var [companies, setCompanies] = useState([]);
    const [companiesLoaded, setCompaniesLoaded] = useState(false);
    var [userList, setUserList] = useState([]);
    const [usersLoaded, setusersLoaded] = useState(false);
    const [userSelected, setUserSelected] = useState(false);
    var [nameKey, setNameKey] = useState();
    var [emailKey, setEmailKey] = useState();
    var [phoneKey, setPhoneKey] = useState();
    const navigate = useNavigate();

    const [loginStatus, setLoginStatus] = useState(false);
    const [updateUser] = useState(true);
    const [open, setOpen] = React.useState(false);
    const [openDeleteUser, setOpenDeleteUser] = React.useState(false);
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [failOpen, setFailOpen] = React.useState(false);
    const [message, setMessage] = useState('');

    const handleClose = () => {
      setOpen(false);
      setOpenDeleteUser(false);
    };

    const handleFailClose = () => {
      setFailOpen(false);
    };

    const handleProceedClose = (e) => {
      userUpdate(e)
      setOpen(false);
    };

    const handleProceedDeleteClose = (e) => {
      deleteUser(e)
      setOpenDeleteUser(false);
    };

    const handleSuccessClose = () => {
      <Navigate to={'/admin/'} />
      {navigate(0)}
    }

    const cancelUpdateUser = () => {
      if (onClose) { onClose(); return; }
      <Navigate to={'/admin/'} />
      {navigate(0)}
    };

    useEffect(()=> {
      if (!localStorage.getItem('token')) {
        setLoginStatus(false);
      } else {
        setLoginStatus(true);
      }
    },[]);

    useEffect(() => {
      if (usersLoaded === false ) {
      const url = baseUrl + 'user/list/';
        fetch(url, {
          method: 'GET',
          headers: {
              'username': localStorage.getItem('username'),
              'bToken': localStorage.getItem('bToken')
          }})
          .then((res) => {
            return res.json();
        }).then((json) => {
            console.log(json)
            setUserList(json);
            setusersLoaded(true);
        })
        .catch((err) => {
           console.log(err.message);
        });
      }
      })

    useEffect(() => {
      if (companiesLoaded === false ) {
      const url = baseUrl + 'company/list/';
        fetch(url, {
          method: 'GET',
          headers: {
              'username': localStorage.getItem('username'),
              'bToken': localStorage.getItem('bToken')
          }})
          .then((res) => {
            return res.json();
        }).then((json) => {
            console.log(json)
            setCompanies(json);
            setCompaniesLoaded(true);
        })
        .catch((err) => {
           console.log(err.message);
        });
      }
      })

    useEffect(()=> {
        console.log(changed);
        console.log('Selected User ',userEdit);
        console.log('Modified User ',modUser);
    });

    async function userUpdate(e) {
        e.preventDefault();
        const url = baseUrl+'user/update';
        await fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'username': localStorage.getItem('username'),
                'bToken': localStorage.getItem('bToken'),
                'selUserId': modUser.id
            },
            body: JSON.stringify(modUser),
        })
        .then((response) => response.json())
          .then((data) => {
            console.log(data)
            if( data.status === 200) {
            setMessage(data.message);
            setSuccessOpen(true);
            } else if (data.status === 401) {
              setMessage(data.message);
              setFailOpen(true);
            }
          })
          .catch((err) => {
            setMessage(err.message);
            setFailOpen(true);
          });
      }

    async function deleteUser(e) {
        e.preventDefault();
        const url = baseUrl+'user/delete';
        await fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'username': localStorage.getItem('username'),
                'bToken': localStorage.getItem('bToken'),
                'selUserId': modUser.id
            },
        })
        .then((response) => response.json())
          .then((data) => {
            console.log(data)
            if( data.status === 200) {
            setMessage(data.message);
            setSuccessOpen(true);
            } else if (data.status === 401) {
              setMessage(data.message);
              setFailOpen(true);
            }
          })
          .catch((err) => {
            setMessage(err.message);
            setFailOpen(true);
          });
      }

    function userDetails(e) {
      const url = baseUrl+'user/details';
      fetch(url, {
          method: 'PATCH',
          headers: {
              'Content-Type': 'application/json',
              'username': localStorage.getItem('username'),
              'bToken': localStorage.getItem('bToken'),
              'selUserId': e
          },
          body: JSON.stringify(modUser),
      })
          .then((response) => {
              if (!response.ok) throw new Error('something went wrong');
              return response.json();
          })
          .then((data) => {
            setUserEdit(data[0]);
            setModUser(data[0]);
            setNameKey(`${Math.floor((Math.random() * 1000))}-min`);
            setPhoneKey(`${Math.floor((Math.random() * 1000))}-min`);
            setEmailKey(`${Math.floor((Math.random() * 1000))}-min`);
          });
    }

  
    return (
      <>
        <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Confirm Update User
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
        <DialogActions>
          <Button onClick={handleProceedClose}>Proceed</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
        <React.Fragment>
      <Dialog
        open={successOpen}
        onClose={handleSuccessClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

        <React.Fragment>
      <Dialog
        open={openDeleteUser}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Confirm Delete User
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
        <DialogActions>
          <Button onClick={handleProceedDeleteClose}>Proceed</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

        <React.Fragment>
      <Dialog
        open={successOpen}
        onClose={handleSuccessClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
        <React.Fragment>
      <Dialog
        open={failOpen}
        onClose={handleFailClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFailClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

    { loginStatus && updateUser && localStorage.getItem('canUpdateUser') === '1' ? (
        <form className="registration" style={{ display: 'flex', flexDirection: 'column', maxHeight: '82vh', margin: 0, width: '100%' }}>
          <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 1.5, borderBottom: '1px solid var(--border)', background: 'var(--surface)' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: 'var(--text)' }}>Update Existing User</Typography>
            {modUser?.id ? (
              <Tooltip title="Delete user">
                <IconButton aria-label="delete user" onClick={setOpenDeleteUser} sx={{ color: 'var(--fail)' }}><DeleteIcon /></IconButton>
              </Tooltip>
            ) : null}
          </Box>
          <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 2 }}>
          <FormControl
          margin="dense"
     fullWidth>
     <InputLabel shrink htmlFor="userNameTitle">
    UserName
  </InputLabel>
        <Select
          native
          label="Username"
          inputProps={{
            id: 'userNameTitle',
          }}
          fullWidth
          onChange={(e) => {
            setUserSelected(true);
            setModUser({
              ...modUser,
              selUserId: e.target.value,
           });
            userDetails(e.target.value);
            }}>
            <option selected disabled>Select Username to Modify</option>
          {
          userList.map((userList) => {
          return <option value={userList.id} key={userList.id}>{userList.userName}</option>
        })
      }
  </Select>
     </FormControl>

     { userSelected ? (
      <>
     <FormControl
          margin="dense"
     fullWidth>
     <InputLabel shrink htmlFor="companyTitle">
    Company *
  </InputLabel>
        <Select
          native
          label="Company   *"
          inputProps={{
            id: 'companyTitle',
          }}
          fullWidth
          onChange={(e) => {
            setChanged(true);
            setModUser({
               ...modUser,
               company: e.target.value,
            });
            }}>
            <option selected disabled>Current: {userEdit.company}</option>
          {
          companies.map((companies) => {
          return <option value={companies.company} key={companies.company}>{companies.description}</option>
        })
      }
  </Select>
     </FormControl>
        <Box>
         <TextField 
        fullWidth
          margin="dense"
          id="name" 
          label="Name" 
          variant="outlined" 
          key= {nameKey}
          value={modUser.name}
          type="text"  
          onChange={(e) => {
            setChanged(true);
            setModUser({
               ...modUser,
               name: e.target.value,
            });
            }}
        />
     </Box>
        <Box>
         <TextField 
        fullWidth
          margin="dense"
          id="email" 
          label="E-Mail Address" 
          key={emailKey}
          variant="outlined" 
          defaultValue={modUser.email}
          type="text"   
          onChange={(e) => {
            setChanged(true);
            setModUser({
               ...modUser,
               email: e.target.value,
            });
            }}
        />
     </Box>
        <Box>
         <TextField 
        fullWidth
          margin="dense"
          id="phone" 
          label="Phone Number" 
          variant="outlined" 
          key={phoneKey}
          defaultValue={modUser.phone}
          type="text" 
          onChange={(e) => {
            setChanged(true);
            setModUser({
               ...modUser,
               phone: e.target.value,
            });
            }}
        />
     </Box>
     <Box sx={{ width: '100%', border: '1px solid var(--border)', borderRadius: 1, mt: 1, mb: 1 }}>
       {[
         { label: 'User Is Active',              key: 'active' },
         { label: 'Can Use Asset Search',        key: 'canSearch' },
         { label: 'Can Add Defects',             key: 'canAddDefect' },
         { label: 'Can Create New Assets',       key: 'canAddAsset' },
         { label: 'Can Edit Existing Assets',    key: 'canEditAsset' },
         { label: 'Can Delete Existing Assets',  key: 'canDeleteAsset' },
         { label: 'Can Inspect Assets',          key: 'canInspectAsset' },
         { label: 'Can Add Attachments',         key: 'canAddAttachment' },
         { label: 'Can Create New Users',        key: 'canRegisterUser' },
         { label: 'Can Edit/Update Users',       key: 'canUpdateUser' },
         { label: 'Can Bulk Upload',             key: 'canBulkAdd' },
         { label: 'Can View Reports',            key: 'canViewPlatformDashboard' },
         { label: 'Can View Admin Reports',      key: 'canAdminReport' },
         { label: 'Can View Schedule',           key: 'canViewSchedule' },
         { label: 'Can Manage Schedule',         key: 'canManageSchedule' },
         { label: 'Can Manage Workshop',         key: 'canManageWorkshop' },
         { label: 'Can View Workshop History',   key: 'canViewWorkshopHistory' },
         { label: 'Can Use Detailed Inspection', key: 'canUseDetailedInspection' },
         { label: 'Can Use Omnix Integration',   key: 'canUseOmnixIntegration' },
       ].map(({ label, key }, i, arr) => (
         <Box key={key} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 0.75, backgroundColor: i % 2 === 0 ? 'var(--surface-2)' : 'var(--surface)', borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none' }}>
           <Box component="span" sx={{ fontSize: '0.875rem', color: 'var(--text)', flex: 1 }}>{label}</Box>
           <Toggle checked={Boolean(modUser[key])} onChange={() => { setChanged(true); setModUser({ ...modUser, [key]: modUser[key] ? 0 : 1 }); }} />
         </Box>
       ))}
     </Box>
</>
      ) : null}
          </Box>{/* end scrollable middle */}
          <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1.5, px: 3, py: 1.5, borderTop: '1px solid var(--border)', background: 'var(--surface)' }}>
            <Button variant="outlined" color="inherit" sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }} onClick={cancelUpdateUser}>Cancel</Button>
            <Button variant="contained" disabled={!changed} onClick={setOpen}>Update User</Button>
          </Box>
        </form>
        ) : null
      }
      </>
    );
  }

export default UpdateUser